import { ExternalLink } from "lucide-react";

export interface Source {
  id: number;
  name: string;
  url: string;
  description?: string;
  date?: string;
}

interface SourcesCitationProps {
  sources: Source[];
}

export const InlineCitation = ({ id }: { id: number }) => (
  <a
    href={`#quelle-${id}`}
    className="text-primary hover:text-primary/80 text-xs align-super font-semibold no-underline"
    title={`Zur Quelle ${id}`}
  >
    [{id}]
  </a>
);

export const SourcesCitation = ({ sources }: SourcesCitationProps) => {
  return (
    <section className="mt-12 pt-8 border-t border-border">
      <h2 className="text-2xl font-bold text-foreground mb-6">Quellen & Referenzen</h2>
      <ol className="space-y-3 list-none pl-0">
        {sources.map((source) => (
          <li key={source.id} id={`quelle-${source.id}`} className="flex items-start gap-3 text-sm text-muted-foreground">
            <span className="font-semibold text-foreground shrink-0">[{source.id}]</span>
            <div>
              <a
                href={source.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="text-primary hover:text-primary/80 inline-flex items-center gap-1"
              >
                {source.name}
                <ExternalLink className="h-3 w-3" />
              </a>
              {source.description && <span className="ml-1">– {source.description}</span>}
              {source.date && <span className="ml-1 text-xs">({source.date})</span>}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};
